<template>
    <v-app :class="scssLocale">
        <router-view />
        <loading-component v-show="this.$store.state.loading" />
        <error-modal v-if="this.$store.state.errorModalShow" />
        <notifications position="bottom right" width="350px" classes="notification"/>
    </v-app>
</template>

<script>

import LoadingComponent from './components/LoadingPage.vue'
import ErrorModal from './components/modal/ErrorModal'

export default {
    name: 'App',

    components: {
        LoadingComponent,
        ErrorModal
    },
    data: () => ({
    }),

    computed: {
        scssLocale () {
            // switch to which scss by current language selected (global.scss)
            return this.$vuetify.lang.current + '-locale'
        }
    }
}
</script>
<style lang="scss">
@import "@/assets/scss/fonts.scss";
// @import "@/assets/scss/global.scss";

</style>
